window.yotpo_translations = [
  {
    "value": "Dual USB 12V Car Charger",
    "fr": "Chargeur allume-cigare double USB 12V",
    "de": "Doppel-USB 12 V Auto-Ladegerät",
    "es": "Cargador doble USB de 12 V para automóvil",
    "it": "Caricabatterie USB doppio da 12 V per auto"
  },
  {
    "value": "USB Charger",
    "fr": "Chargeur USB",
    "de": "USB-Ladegerät",
    "es": "Cargador USB",
    "it": "Caricabatterie USB"
  },
  {
    "value": "Vibration Dampener",
    "fr": "Amortisseur de vibrations",
    "de": "Vibrationsdämpfer",
    "es": "Amortiguador de vibraciones",
    "it": "Smorzatore di vibrazioni"
  },
  {
    "value": "Waterproof 12V To USB Smart Adaptor",
    "fr": "Adaptateur intelligent étanche 12V vers USB",
    "de": "Wetterfester 12 V auf USB Smart-Adapter",
    "es": "Adaptador inteligente de 12 V a USB resistente a la intemperie",
    "it": "Adattatore intelligente da 12 V a USB resistente alle intemperie"
  },
  {
    "value": "2 x Spacers (10mm)",
    "fr": "2x Douilles d'espacement (10 mm)",
    "de": "2 x Distanzhülsen (10mm)",
    "es": "2 espaciadores (10 mm)",
    "it": "2 distanziali (10 mm)"
  },
  {
    "value": "Dual Pivot",
    "fr": "Double Pivot",
    "de": "Doppel-Gelenkarm",
    "es": "Pivote doble",
    "it": "Perno doppio"
  },
  {
    "value": "Extension Arm (50mm)",
    "fr": "Bras de rallonge (50mm)",
    "de": "Verlängerungsarm (50 mm)",
    "es": "Brazo extensor (50 mm)",
    "it": "Braccio estensivo (50 mm)"
  },
  {
    "value": "Knuckle Adaptor",
    "fr": "Adaptateur articulé",
    "de": "Gelenk-Adapter",
    "es": "Adaptador articulado",
    "it": "Adattatore a nocca"
  },
  {
    "value": "Single Pivot",
    "fr": "Pivot Simple",
    "de": "Einzel-Gelenkarm",
    "es": "Pivote individual",
    "it": "Perno singolo"
  },
  {
    "value": "Bar Clamp",
    "fr": "Collier de serrage pour tube",
    "de": "Lenker-Klemme",
    "es": "Abrazadera de manillar",
    "it": "Morsetto da manubrio"
  },
  {
    "value": "Concealed Small",
    "fr": "Discrète Petit",
    "de": "Klein",
    "es": "Pequeña oculta",
    "it": "A scomparsa (piccola)"
  },
  {
    "value": "Flat Rectangle Base",
    "fr": "Base Plate Rectangulaire",
    "de": "Rechteckige Befestigungsplatte",
    "es": "Base rectangular plana",
    "it": "Base rettangolare piatta"
  },
  {
    "value": "Flexible Adhesive",
    "fr": "Base Adhésive Flexible",
    "de": "Flexible Klebebefestigung",
    "es": "Adhesiva flexible",
    "it": "Base adesiva flessibile"
  },
  {
    "value": "12V-24V Waterproof Wireless Charging Head",
    "fr": "12V-24V Tête de chargeur sans fil imperméable",
    "de": "12V-24V Wasserdichtes Kabelloses Ladekopf",
    "es": "Cabezal de carga inalámbrica de 12 V-24 V resistente a la intemperie",
    "it": "Testa caricabatterie wireless resistente alle intemperie da 12-24 V"
  },
  {
    "value": "Lever Head",
    "fr": "Levier de blocage",
    "de": "Kopf mit Hebel",
    "es": "Cabezal de palanca",
    "it": "Testa a levetta"
  },
  {
    "value": "MAG Head",
    "fr": "Tête MAG",
    "de": "MAG-Kopf",
    "es": "Cabezal MAG",
    "it": "Testa MAG"
  },
  {
    "value": "MAG Wireless Charging Head",
    "fr": "Tête MAG de chargement sans fil",
    "de": "MAG-Kabelloser Ladekopf",
    "es": "Cabezal de carga inalámbrica MAG",
    "it": "Testa MAG caricabatterie wireless"
  },
  {
    "value": "Top Cap",
    "fr": "Top Cap",
    "de": "Kappe",
    "es": "Tapa superior",
    "it": "Attacco superiore"
  },
  {
    "value": "USB Weatherproof Wireless Charging Head",
    "fr": "USB Tête de chargement sans fil résistante aux intempéries",
    "de": "USB Wetterfester Kabelloser Ladekopf",
    "es": "Cabezal de carga inalámbrica USB resistente a la intemperie",
    "it": "Testa caricabatterie wireless USB resistente alle intemperie"
  },
  {
    "value": "Wireless Charging Head",
    "fr": "Tête de chargement sans fil",
    "de": "Kabelloser Ladekopf",
    "es": "Cabezal de carga inalámbrica",
    "it": "Testa caricabatterie wireless"
  },
  {
    "value": "Action Camera",
    "fr": "Caméra d'action",
    "de": "Action-Kamera",
    "es": "Cámara de acción",
    "it": "Action cam"
  },
  {
    "value": "Suction",
    "fr": "Ventouse",
    "de": "Saugfuß",
    "es": "Succión",
    "it": "Ventosa"
  },
  {
    "value": "Single Bolt - M8",
    "fr": "À tige filetée - M8",
    "de": "Einzelschraube - M8",
    "es": "Un solo tornillo - M8",
    "it": "Bullone singolo - M8"
  },
  {
    "value": "Quad Lock to Action Camera Adaptor",
    "fr": "Adapteur pour caméra d'action avec attachement Quad Lock",
    "de": "Action-Kamera Auf Quad-Lock-Adapter",
    "es": "Adaptador de cámara de acción a Quad Lock",
    "it": "Adattatore da Quad Lock a action cam"
  }
]
